namespace RioERP.Reports {
    export interface OrderPaymentForm {
        OrderId: Serenity.LookupEditor;
        EPaymentMode: Serenity.EnumEditor;
        Amount: Serenity.DecimalEditor;
        EStatus: Serenity.EnumEditor;
        Note: Serenity.StringEditor;
        ChequeNumber: Serenity.StringEditor;
        BankName: Serenity.StringEditor;
        TransactionId: Serenity.StringEditor;
        PaymentDate: Serenity.DateEditor;
    }

    export class OrderPaymentForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.OrderPayment';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderPaymentForm.init)  {
                OrderPaymentForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.EnumEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.StringEditor;
                var w4 = s.DateEditor;

                Q.initFormType(OrderPaymentForm, [
                    'OrderId', w0,
                    'EPaymentMode', w1,
                    'Amount', w2,
                    'EStatus', w1,
                    'Note', w3,
                    'ChequeNumber', w3,
                    'BankName', w3,
                    'TransactionId', w3,
                    'PaymentDate', w4
                ]);
            }
        }
    }
}
